module.exports = __webpack_public_path__ + "static/img/wxImg.c463bb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wxImg.jpg
// module id = lR4L
// module chunks = 1